import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';
import {
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import Modal from '../../elements/Modal';
import NewExpense from './new';
import EditExpense from './edit';

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;

  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
`;

const BoldLinkText = styled(Text)`
  font-weight: bold;
`;

const SubNav = ({expense, refetch}) => {
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [showEditExpenseModal, setShowEditExpenseModal] = useState(false);
  const loc = useLocation();
  return (
    <NavbarContainer>
      {getLinks()}
    </NavbarContainer>
  )

  function getLinks() {
    if(loc.pathname === '/expenses') {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddExpenseModal(true)}
          >
            <Text>+ Add Expense</Text>
          </Pressable>
          {showAddExpenseModal &&
            <Modal
              showModal={showAddExpenseModal}
              setShowModal={setShowAddExpenseModal}
              modalType={'Add Expense'}
              expenseId={expense?.id}
            >
              <NewExpense
                setShowModal={setShowAddExpenseModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(loc.pathname === '/expenses/new') {
      return (
        <Link to={`/expenses`}>
          <Text>Expenses</Text>
        </Link>
      )
    }else {
      return (
        <LinkContainer>
          {/* <BoldLinkText>{expense.name}</BoldLinkText> */}
          <LinkSpace />
          <Pressable
            onPress={() => {
              setShowEditExpenseModal(true)
            }}
          >
            <Text>
              Edit
            </Text>
          </Pressable>
          {showEditExpenseModal &&
            <Modal
              refetch={refetch}
              showModal={showEditExpenseModal}
              setShowModal={setShowEditExpenseModal}
              modalType={'Edit Expense'}
              objectName={'Expense'}
            >
              <EditExpense
                setShowModal={setShowEditExpenseModal}
                refetch={refetch}
                expense={expense}
              />
            </Modal>
          }
        </LinkContainer>
      )
    }
  }
}

export default SubNav;
